import HttpService from "common/http/httpService";
import { ContractType } from "domain/contract";
import { DeliveryMethod } from "domain/deliveryMethod";

class DeliveryMethodService extends HttpService {
    async list(contractType: ContractType): Promise<DeliveryMethod[]> {
        const response = await this.getClient()
            .get<DeliveryMethod[]>("/offers/v1/delivery-methods", {
                params: {
                    contractType
                }
            });
        return response.data;
    }

    async listAll(): Promise<DeliveryMethodsByContractType> {
        const response = await this.getClient()
            .get<DeliveryMethodsByContractType>("/offers/v2/delivery-methods");
        return response.data;
    }
}

export type DeliveryMethodsByContractType = { [index: number]: DeliveryMethod[] };

const deliveryMethodService = new DeliveryMethodService();

export default deliveryMethodService;